import { Fetcher, objectToFormData } from '@this/src/util';
import React from 'react';
import { TextField } from '../../shared/form_elements/form_elements';
import SimpleLoading from '../../shared/simple_loading/simple_loading';

interface ResetPasswordResponse {
  redirect: string;
}

export interface ResetPasswordProps {
  token: string;
}

interface State {
  newPassword: string;
  newPasswordConfirmation: string;
  resetSuccess?: string;
  resetErrors: string[];
  resetting: boolean;
  resetPasswordToken: string;
}

const getStyles = () => ({
  container: {
    maxWidth: '600px',
    width: '100%',
    margin: '50px auto'
  },
  content: {
    height: 'fit-content' as const,
    padding: '20px',
    background: 'white',
    fontSize: '16px',
    fontWeight: 'bold' as const
  }
});

export default class ResetPassword extends React.Component<ResetPasswordProps, State> {
  constructor(props: ResetPasswordProps) {
    super(props);
    this.state = {
      newPassword: '',
      newPasswordConfirmation: '',
      resetErrors: [],
      resetting: false,
      resetPasswordToken: props.token
    };
  }

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.setState({ resetting: true, resetErrors: [] });
    try {
      const params = this.params();
      const result = await Fetcher.put<ResetPasswordResponse>(
        '/aiexpense/users/password',
        objectToFormData(params)
      );
      this.setState(
        {
          resetting: false,
          resetErrors: [],
          resetSuccess: 'リセットに成功しました。ログインページにジャンプします...'
        },
        () => {
          setTimeout(() => {
            location.href = result.redirect;
          }, 1000);
        }
      );
    } catch (e) {
      if (e.response.data && e.response.data.errors) {
        this.setState({
          resetting: false,
          resetErrors: e.response.data.errors
        });
      } else {
        this.setState({
          resetting: false,
          resetErrors: ['通信環境が不安定です。\n時間をおいてもう一度お試しください。']
        });
      }
    }
  };

  params() {
    return {
      'user[new_password]': this.state.newPassword,
      'user[new_password_confirmation]': this.state.newPasswordConfirmation,
      'user[reset_password_token]': this.state.resetPasswordToken
    };
  }

  handleNewPasswordChange(value: string) {
    this.setState({ newPassword: value });
  }

  handleNewPasswordConfirmationChange(value: string) {
    this.setState({ newPasswordConfirmation: value });
  }

  render() {
    const styles = getStyles();
    const { newPassword, newPasswordConfirmation, resetting, resetErrors, resetSuccess } = this.state;
    const classBase = 'expenses-users-signup';
    return (
      <div className={classBase} style={styles.container}>
        <div className={`${classBase}__content`} style={styles.content}>
          <form onSubmit={this.handleSubmit}>
            <TextField
              label="新しいパスワード（必須）"
              value={newPassword}
              example=""
              type="password"
              onChange={value => this.handleNewPasswordChange(value)}
            />
            <TextField
              label="確認（必須）"
              value={newPasswordConfirmation}
              example=""
              type="password"
              onChange={value => this.handleNewPasswordConfirmationChange(value)}
            />
            {resetErrors.length > 0 && (
              <div className="expenses-users-signup__message">
                {resetErrors.map((e, i) => (
                  <p key={i} className="error">
                    {e}
                  </p>
                ))}
              </div>
            )}
            {resetting ? (
              <SimpleLoading />
            ) : resetSuccess ? (
              <p>{resetSuccess}</p>
            ) : (
              <input type="submit" value="リセット" disabled={resetting} />
            )}
          </form>
        </div>
      </div>
    );
  }
}
